import React from 'react';
import { connect } from 'react-redux';
import Config from 'configuration';

import { DEBUG_NONCE_OVERRIDE_OPTIONS } from 'components/PaymentNonceDebugOverride/constants';
import { IAppState } from 'types/app';

type OwnProps = {
  onSelect: (nonce: string) => void,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export function PaymentNonceDebugOverride({ onSelect }: Props) {
  if (['local', 'staging'].indexOf(Config.environment) < 0) {
    console.info('whoops, nope,');
    return null;
  }


  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {DEBUG_NONCE_OVERRIDE_OPTIONS.map(({ label, value }) => (
        <label key={value}>
          <input
            type="radio"
            value={value}
            onChange={() => onSelect(value)}
            name="set-nonce"
            defaultChecked={value === ''}
            style={{
              marginRight: '8px',
            }}
          />
          {label}
        </label>
      ))}
    </div>
  );
}

const mapStateToProps = ({ user: { privilegeLevel } }: IAppState) => ({
  privilegeLevel,
});

export default connect(mapStateToProps)(PaymentNonceDebugOverride);